<template>
  <div>
    <img
      v-if="imagePath != null"
      :src="imagePath"
      alt="image"
      :style="`height: ${height};width: ${width};object-fit: cover`"
    >
    <img
      v-else
      src="/resources/images/no-photo-available.png"
      :style="`height: ${height};width: ${width};object-fit: cover`"
    >
  </div>
</template>

<script>
const baseUrl = process.env.VUE_APP_API_CDN

export default {
  name: 'ImageView',
  props: {
    image: {
      type: Object,
      default () {
        return null
      },
    },
    type: {
      type: String,
      default () {
        return 'full'
      },
    },
    height: {
      type: String,
      default () {
        return '100%'
      },
    },
    width: {
      type: String,
      default () {
        return 'auto'
      },
    },
  },
  computed: {
    imagePath () {
      if (this.image && this.image[this.type]) {
        return (this.image[this.type].path.startsWith('https://') ? '' : baseUrl) + this.image[this.type].path
      } else {
        return null
      }
    },
  },
}
</script>

<style scoped>

</style>
